import { render } from "./DeviceCopyConfigSlide.vue?vue&type=template&id=5ab8ba42"
import script from "./DeviceCopyConfigSlide.vue?vue&type=script&lang=js"
export * from "./DeviceCopyConfigSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__